<div class="inicio scroll-smooth min-h-screen flex items-center justify-center bg-gradient-to-r from-blue-600 to-green-600">
    <div class="container mx-auto px-4 text-center text-white">
        <p class="text-xl md:text-2xl mb-8">
            Tu asistente virtual para consultas sobre la tasa de seguridad ciudadana
        </p>

        <!-- Loading spinner -->
        <div class="flex flex-col items-center">
            <div class="animate-spin rounded-full h-16 w-16 border-4 border-white border-t-transparent mb-4"></div>
            <p class="text-lg opacity-80">Conectando al chat...</p>
        </div>
    </div>
</div>